import {Badge} from 'react-bootstrap'
import {getBootstrapColorHex, getContrastTextColor} from '../../../helpers/consts'



export const BadgeStatePolicy = ({status, color = 'primary'}: {status: string; color?: string}) => {
  const bgColor = getBootstrapColorHex(color)
  const textColor = getContrastTextColor(bgColor)
  return (
    <Badge
      className='custom-badge'
      style={{
        backgroundColor: bgColor,
        color: textColor,
        border: textColor === '#000000' ? '1px solid #ccc' : 'none',
        ['--custom-bg' as any]: bgColor,  // 👈 para CSS que usa var(--custom-bg)
        ['--custom-fg' as any]: textColor // 👈 si decides usar var(--custom-fg) en tu CSS
      }}
    >
      {status}
    </Badge>
  )
}
